export * from '../src/composites/wui-input-amount/index.js';
//# sourceMappingURL=wui-input-amount.js.map